import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7c60a96"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "approval-header",
  class: "px-6 pt-6"
}
const _hoisted_2 = { class: "icon-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "sub-title mt-2",
  "data-testid": "subtitle"
}
const _hoisted_5 = {
  class: "title mt-4",
  "data-testid": "title"
}
const _hoisted_6 = { class: "actions" }

type Props = {
  icon?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalHeader',
  props: {
    icon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "icon",
            src: _ctx.icon
          }, null, 8 /* PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("h3", _hoisted_4, [
      _renderSlot(_ctx.$slots, "subtitle")
    ]),
    _createElementVNode("h1", _hoisted_5, [
      _renderSlot(_ctx.$slots, "title")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "actions")
    ])
  ]))
}
}

})